var widget_default = {
  "card": "sanep",
  "link": "wCXKO",
  "container": "_78-SI",
  "image": "IYVoD",
  "right": "NBMiE",
  "cardLayout": "JN2Fn",
  "content": "n6y5n",
  "title": "C6Uqt",
  "subtitle": "uD1qy",
  "button": "_1F1vQ",
  "button_disabled": "yYGE3",
  "buttonText": "nFer0",
  "slimLayout": "_9QKfd",
  "contentText": "PCPmm"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
